import obscureString from './obscureString'

const obscureEmail = (email: string): string => {
  return email.replace(/([\w.]+)@([\w.]+)(\.[\w.]+)/g, (_, p1, p2, p3) => `${obscureString(p1)}@${obscureString(p2)}${p3}`)
}

export default obscureEmail
